// Public (guest-readable) routes — lazy-loaded (doc 04 §8.2).
import type { RouteRecordRaw } from 'vue-router'

export const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/public/HomePage.vue'),
    meta: { layout: 'public', public: true, title: 'CPA — Caraga Pickleball' },
  },
  {
    path: '/rankings',
    name: 'rankings',
    component: () => import('@/pages/public/RankingsPage.vue'),
    meta: { layout: 'public', public: true, title: 'Rankings' },
  },
  {
    path: '/players',
    name: 'players',
    component: () => import('@/pages/public/PlayersPage.vue'),
    meta: { layout: 'public', public: true, title: 'Players' },
  },
  {
    // `:id` accepts a numeric id or a player_code (e.g. CPA-XIII-000123).
    path: '/players/:id',
    name: 'player-profile',
    component: () => import('@/pages/public/PlayerProfilePage.vue'),
    meta: { layout: 'public', public: true, title: 'Player Profile' },
    props: true,
  },
  {
    path: '/tournaments',
    name: 'tournaments',
    component: () => import('@/pages/public/TournamentsPage.vue'),
    meta: { layout: 'public', public: true, title: 'Tournaments' },
  },
  {
    // `:slug` accepts a tournament slug or numeric id.
    path: '/tournaments/:slug',
    name: 'tournament-detail',
    component: () => import('@/pages/public/TournamentDetailPage.vue'),
    meta: { layout: 'public', public: true, title: 'Tournament' },
    props: true,
  },
  {
    path: '/courts',
    name: 'courts',
    component: () => import('@/pages/public/CourtsPage.vue'),
    meta: { layout: 'public', public: true, title: 'Courts' },
  },
  {
    // `:id` accepts a numeric id or a court slug (e.g. butuan-pickle-dome).
    path: '/courts/:id',
    name: 'court-detail',
    component: () => import('@/pages/public/CourtDetailPage.vue'),
    meta: { layout: 'public', public: true, title: 'Court' },
    props: true,
  },
  {
    path: '/clubs',
    name: 'clubs',
    component: () => import('@/pages/public/ClubsPage.vue'),
    meta: { layout: 'public', public: true, title: 'Clubs' },
  },
  {
    // `:slug` accepts a club slug or numeric id.
    path: '/clubs/:slug',
    name: 'club-detail',
    component: () => import('@/pages/public/ClubDetailPage.vue'),
    meta: { layout: 'public', public: true, title: 'Club' },
    props: true,
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/pages/public/NewsPage.vue'),
    meta: { layout: 'public', public: true, title: 'News' },
  },
  {
    // `:slug` accepts a news slug or numeric id.
    path: '/news/:slug',
    name: 'news-detail',
    component: () => import('@/pages/public/NewsDetailPage.vue'),
    meta: { layout: 'public', public: true, title: 'Article' },
    props: true,
  },
]
